import { useState } from 'react';
import { useTranslation } from 'react-i18next';

import { BlueButton, WhiteButton } from '../oval-button/oval-button';
import { Indicator } from '../indicator/indicator';
import { Content, Arrow, Buttons, Item } from './radio-popup.styled';

export const RadioPopup = (props) => {
  const { t } = useTranslation();
  const { simple, buttons, value, close, submit, disabled } = props;
  const [current, setCurrent] = useState(value);

  if (!buttons || !value) {
    return null;
  }

  /**
   * get buttons
   * @returns
   */
  const getButtons = () => {
    return buttons.map((el, idx) => {
      const setValue = () => {
        if (disabled || el.disabled) {
          return;
        }
        setCurrent(el.value);
      };

      return (
        <Item key={idx} onClick={setValue}>
          <Indicator className="sm" active={current === el.value} /> {el.name}
        </Item>
      );
    });
  };

  /**
   * send result
   */
  const doSubmit = () => {
    submit(current);
  };

  const itemsEl = getButtons();
  const btnTitle = simple ? 'Применить' : 'Отправить';

  return (
    <Content $simple={simple}>
      {!simple && <Arrow />}
      {itemsEl}
      <Buttons>
        {!simple && <WhiteButton onClick={close}>{t('buttons.Отменить')}</WhiteButton>}
        <BlueButton onClick={doSubmit} disabled={disabled}>
          {t('buttons.' + btnTitle)}
        </BlueButton>
      </Buttons>
    </Content>
  );
};
